
import Header from '../component/Header/Header'
import PlainTextContent from '../component/PlainTextContent/PlainTextContent'
import FooterNew from '../component/FooterNew/FooterNew'
import PlainImgTextContent from '../component/PlainImgTextContent/PlainImgTextContent'
import AboutCustomText from '../component/AboutCustomText/AboutCustomText'


function About() {
  return (
    <>
        <Header/>
   
         <PlainTextContent
         heading='Turn your truth into strategy—and your story into impact.'
         content={'At Divitiis, we believe powerful brand stories start with radical honesty. We help entrepreneurs, creatives, and change-makers shed the mask, own what sets them apart, and lead with confidence. Through strategy, story, and bold execution, we turn realness into resonance—and authenticity into influence.'}
         btnText=''
         btnRef='/'
         bgColor="#3D4335"
         fontThemeDark={false}
         btnClass='btn-pink'
         />
   
    <AboutCustomText/>
       
   
           <FooterNew/>
   
    </>
  )
}

export default About